import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
const Donation = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <HeaderSection 
               title="Donation" 
               smallTitle="Donote To " 
               usmallTitle="Smart Shopper"
               />
               <section id="section_shop">
                   <div id="order_id_div">
                      <p id="order_id_text">
                      Thank you for your generous gift to Smart Shopper. We are thrilled to have your support. Through your donation we have been able to accomplish good service and continue working towards to make it available. You truly make the difference for us, and we are extremely grateful!
                      </p>
                     <hr id="order_id_hr" />
                     <label id="order_id_labal">Email</label>
                     <input type="text"  id="order_id_div_input"/>
                     <label id="order_id_labal">Amount</label>
                     <input type="text"  id="order_id_div_input"/>
                     <button id="order_id_button">Sent Donation</button>
                   </div>
                   
               </section>
            <Footer />
        </div>
    )
}
export default Donation;
